// extracted by mini-css-extract-plugin
module.exports = {"button":"checkbox_button__uTZIm","label":"checkbox_label__lYijr","title":"checkbox_title__D1IpO","description":"checkbox_description__03cMB"};